export const tableNumber = (index: number, page: string) => {
  const pageNumber = page ? page : 1;
  return index + 1 + (10 * (Number(pageNumber) - 1) ?? 0);
};
